// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ── LoginModal.css (Data Lift v2 Ultra-Premium Glassmorphic Theme) ── */

.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  /* Dark mode: softer dark overlay so the app's beautiful background shines through */
  background: rgba(2, 6, 23, 0.65);
  backdrop-filter: blur(16px) saturate(140%);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: modalFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

html[data-theme="light"] .login-modal-overlay {
  background: rgba(241, 245, 249, 0.7);
  backdrop-filter: blur(24px) saturate(150%);
}

@keyframes modalFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.login-modal-card-container {
  position: relative;
  width: 95%;
  max-width: 1000px;
  height: 640px;
  animation: cardSlideIn 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  /* Dark mode: strong subtle shadow */
  box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.8), 0 0 40px rgba(14, 165, 233, 0.1);
  border-radius: 28px;
}

html[data-theme="light"] .login-modal-card-container {
  box-shadow: 0 30px 60px -15px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0,0,0,0.05);
}

@keyframes cardSlideIn {
  from { transform: translateY(30px) scale(0.95); opacity: 0; }
  to { transform: translateY(0) scale(1); opacity: 1; }
}

.login-modal-close-btn {
  position: absolute;
  top: -45px;
  right: 0;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #94a3b8;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10005;
  backdrop-filter: blur(12px);
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.login-modal-close-btn:hover {
  transform: scale(1.1) rotate(90deg);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.3);
  background: rgba(15, 23, 42, 0.9);
  box-shadow: 0 0 15px rgba(255,255,255,0.1);
}

html[data-theme="light"] .login-modal-close-btn {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  color: #64748b;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

html[data-theme="light"] .login-modal-close-btn:hover {
  color: #0f172a;
  border-color: #cbd5e1;
}

/* ── Layout ── */
.auth-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  border-radius: 28px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.05);
  overflow: hidden;
}

html[data-theme="light"] .auth-container {
  background: #ffffff;
  border: none;
  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 1);
}

/* ── LEFT PANEL ── */
.auth-left-panel {
  width: 45%;
  /* Dark mode: vibrant rich blue gradient to create stunning contrast */
  background-color: #020617;
  background-image: 
    radial-gradient(circle at 15% 50%, rgba(99, 102, 241, 0.22), transparent 50%),
    radial-gradient(circle at 85% 30%, rgba(14, 165, 233, 0.25), transparent 50%),
    radial-gradient(circle at 50% 100%, rgba(16, 185, 129, 0.15), transparent 50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2.5rem;
  color: white;
  position: relative;
  overflow: hidden;
  border-right: 1px solid rgba(255, 255, 255, 0.05);
}



.auth-left-panel::after {
  content: '';
  position: absolute;
  inset: 0;
  background-size: 40px 40px;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.04) 1px, transparent 1px),
                    linear-gradient(to bottom, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  pointer-events: none;
  z-index: 1;
}

.auth-left-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.auth-avatar-icon {
  margin-bottom: 1.8rem;
  color: #ffffff;
  filter: drop-shadow(0 4px 20px rgba(255, 255, 255, 0.3));
  transform: scale(1.1);
}

html[data-theme="light"] .auth-avatar-icon {
  color: #38bdf8;
  filter: drop-shadow(0 0 15px rgba(56, 189, 248, 0.4));
}

.auth-left-content h2 {
  font-family: 'Outfit', sans-serif;
  font-size: 2.4rem;
  font-weight: 800;
  margin-bottom: 1.2rem;
  line-height: 1.15;
  letter-spacing: -0.03em;
  background: linear-gradient(to right, #ffffff, #94a3b8);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: none;
}



.auth-left-content p {
  font-size: 0.95rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.75);
  margin-bottom: 2.5rem;
  max-width: 320px;
}



.auth-feature-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  max-width: 340px;
}

.auth-feature-chips .chip {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(56, 189, 248, 0.2);
  color: #e0f2fe;
  padding: 0.45rem 1rem;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  backdrop-filter: blur(12px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.auth-feature-chips .chip.active {
  background: rgba(14, 165, 233, 0.25);
  border-color: rgba(14, 165, 233, 0.6);
  color: #ffffff;
  box-shadow: 0 0 12px rgba(14, 165, 233, 0.3);
}

.auth-feature-chips .chip.disabled {
  background: rgba(15, 23, 42, 0.3);
  border-color: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.4);
  cursor: not-allowed;
  box-shadow: none;
}

.auth-feature-chips .chip:hover:not(.disabled) {
  background: rgba(56, 189, 248, 0.15);
  border-color: rgba(56, 189, 248, 0.4);
  transform: translateY(-2px);
}



/* ── RIGHT PANEL (FORMS) ── */
.auth-right-panel {
  width: 55%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 2rem 4rem;
  position: relative;
  /* Dark mode: Ultra-premium dark frosted glass to contrast with vibrant left */
  background: rgba(10, 15, 30, 0.4);
  backdrop-filter: blur(40px) saturate(200%);

  overflow-y: auto;
  scrollbar-width: none;
}
.auth-right-panel::-webkit-scrollbar {
  display: none;
}

html[data-theme="light"] .auth-right-panel {
  background: #ffffff;
  backdrop-filter: none;

  overflow-y: auto;
  scrollbar-width: none;
}
.auth-right-panel::-webkit-scrollbar {
  display: none;
}

.auth-content {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: auto 0;
}

.fade-in {
  animation: fadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

/* ── Typography ── */
.auth-content h1 {
  font-family: 'Outfit', sans-serif;
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
  letter-spacing: -0.03em;
  color: #ffffff;
  text-align: left;
}

html[data-theme="light"] .auth-content h1 {
  color: #0f172a;
}

.auth-form-subtitle {
  font-size: 0.95rem;
  color: #94a3b8;
  margin-bottom: 2rem;
  text-align: left;
  line-height: 1.5;
}

html[data-theme="light"] .auth-form-subtitle {
  color: #64748b;
}

/* ── Forms and Inputs ── */
.auth-content form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.input-group {
  position: relative;
  width: 100%;
}

.input-group input {
  width: 100%;
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 0.75rem 1rem 0.75rem 2.8rem !important;
  border-radius: 12px !important;
  color: #ffffff !important;
  font-size: 0.95rem;
  transition: all 0.25s ease !important;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.2) !important;
}

html[data-theme="light"] .input-group input {
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  color: #0f172a !important;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.02) !important;
}

.input-group input:focus {
  border-color: #38bdf8 !important;
  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.2) !important;
  background: rgba(0, 0, 0, 0.5) !important;
  outline: none;
}

html[data-theme="light"] .input-group input:focus {
  border-color: #0ea5e9 !important;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;
  background: #ffffff !important;
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
  pointer-events: none;
  transition: color 0.3s ease;
  z-index: 10;
}

.input-group input:focus + .input-icon {
  color: #38bdf8;
}

html[data-theme="light"] .input-group input:focus + .input-icon {
  color: #0ea5e9;
}

/* Checkbox & Forgot Password */
.auth-form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  margin: 0.2rem 0 0.5rem 0;
  width: 100%;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #cbd5e1;
}

html[data-theme="light"] .remember-me {
  color: #475569;
}

.checkbox-custom {
  height: 18px;
  width: 18px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  position: relative;
  transition: all 0.2s;
}

html[data-theme="light"] .checkbox-custom {
  background: #ffffff;
  border-color: #cbd5e1;
}

.remember-me input:checked ~ .checkbox-custom {
  background: #0ea5e9;
  border-color: #0ea5e9;
}

.checkbox-custom:after {
  content: "";
  position: absolute;
  display: none;
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.remember-me input:checked ~ .checkbox-custom:after { display: block; }

.forgot-password {
  margin-left: auto;
}

.forgot-password a {
  color: #38bdf8;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s;
}

html[data-theme="light"] .forgot-password a {
  color: #0ea5e9;
}

.forgot-password a:hover {
  color: #e0f2fe;
}

html[data-theme="light"] .forgot-password a:hover {
  color: #0284c7;
}

/* Submit Button */
.auth-submit-btn {
  width: 100%;
  padding: 0.9rem;
  border-radius: 12px;
  border: none;
  background: #0ea5e9;
  color: white;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(14, 165, 233, 0.4);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  margin-top: 0.5rem;
}

html[data-theme="light"] .auth-submit-btn {
  background: #0f172a;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);
}

.auth-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  background: #38bdf8;
  box-shadow: 0 8px 25px rgba(56, 189, 248, 0.5);
}

html[data-theme="light"] .auth-submit-btn:hover:not(:disabled) {
  background: #1e293b;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.25);
}

.auth-submit-btn:disabled {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.3);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

html[data-theme="light"] .auth-submit-btn:disabled {
  background: #e2e8f0;
  color: #94a3b8;
  border: none;
}

/* Switcher Link */
.auth-switch-link {
  margin-top: 2rem;
  font-size: 0.95rem;
  text-align: center;
}

.auth-switch-link .text-muted {
  color: #94a3b8;
}

html[data-theme="light"] .auth-switch-link .text-muted {
  color: #64748b;
}

.switch-btn {
  background: none;
  border: none;
  color: #38bdf8;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  font-size: 0.95rem;
  transition: color 0.2s;
}

html[data-theme="light"] .switch-btn {
  color: #0ea5e9;
}

.switch-btn:hover {
  color: #e0f2fe;
  text-decoration: underline;
}

html[data-theme="light"] .switch-btn:hover {
  color: #0284c7;
}

/* Dividers & Footer */
.divider-text {
  width: 100%;
  text-align: center;
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 600;
  margin: 1.2rem 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  position: relative;
  display: flex;
  align-items: center;
}

.divider-text::before, .divider-text::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: rgba(255,255,255,0.1);
  margin: 0 10px;
}

html[data-theme="light"] .divider-text::before,
html[data-theme="light"] .divider-text::after {
  background: rgba(0,0,0,0.1);
}

.copyright-tag {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 2rem;
  text-align: center;
}

/* SSO Buttons */
.sso-buttons-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.google-sso-btn, .github-sso-btn {
  width: 100%;
  padding: 0.85rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

html[data-theme="light"] .google-sso-btn, 
html[data-theme="light"] .github-sso-btn {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #0f172a;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
}

.google-sso-btn:hover, .github-sso-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

html[data-theme="light"] .google-sso-btn:hover, 
html[data-theme="light"] .github-sso-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

/* Error/Success Badges */
.auth-error-badge {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: #fca5a5;
  padding: 0.8rem;
  border-radius: 10px;
  font-size: 0.85rem;
  width: 100%;
  margin-bottom: 1.5rem;
  text-align: center;
}

html[data-theme="light"] .auth-error-badge {
  background: #fef2f2;
  border-color: #fecaca;
  color: #ef4444;
}

.auth-success-badge {
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.2);
  color: #6ee7b7;
  padding: 0.8rem;
  border-radius: 10px;
  font-size: 0.85rem;
  width: 100%;
  margin-bottom: 1.5rem;
  text-align: center;
}

html[data-theme="light"] .auth-success-badge {
  background: #ecfdf5;
  border-color: #a7f3d0;
  color: #059669;
}

/* Responsive */
@media (max-width: 768px) {
  .auth-container { flex-direction: column; }
  .auth-left-panel { display: none; }
  .auth-right-panel { width: 100%; padding: 2rem; 
  overflow-y: auto;
  scrollbar-width: none;
}
.auth-right-panel::-webkit-scrollbar {
  display: none;
}
}

/* EF-Methods overrides */
.ef-email-badge {
  display: flex; align-items: center; justify-content: center;
  font-size: 0.85rem; font-weight: 600; color: #cbd5e1;
  background: rgba(0, 0, 0, 0.3); border: 1px solid rgba(255,255,255,0.1);
  border-radius: 8px; padding: 0.5rem 1rem; margin-bottom: 1rem; width: 100%;
}
html[data-theme="light"] .ef-email-badge {
  background: #f8fafc; border-color: #e2e8f0; color: #475569;
}
.ef-methods-label { font-size: 0.85rem; font-weight: 600; color: #94a3b8; margin-bottom: 1rem; }
.ef-method-btn {
  width: 100%; display: flex; align-items: center; gap: 12px;
  padding: 0.9rem; border-radius: 12px; border: 1px solid rgba(255,255,255,0.1);
  background: rgba(0, 0, 0, 0.2); color: #e2e8f0; font-weight: 600; cursor: pointer;
  margin-bottom: 0.6rem; transition: all 0.2s;
}
html[data-theme="light"] .ef-method-btn {
  background: #ffffff; border-color: #e2e8f0; color: #1e293b;
}
.ef-method-btn:hover { background: rgba(255,255,255,0.05); border-color: rgba(255,255,255,0.2); }
html[data-theme="light"] .ef-method-btn:hover { background: #f8fafc; border-color: #cbd5e1; }
.ef-method-icon { color: #94a3b8; }
.ef-method-arrow { margin-left: auto; color: #64748b; }
.ef-back-link {
  background: none; border: none; color: #64748b; font-weight: 600; cursor: pointer; margin-top: 1rem;
}
.ef-back-link:hover { color: #38bdf8; }
html[data-theme="light"] .ef-back-link:hover { color: #0ea5e9; }

.ef-no-account, .ef-otp-sent { text-align: center; width: 100%; }
.ef-no-account-icon, .ef-otp-sent-icon {
  width: 50px; height: 50px; border-radius: 50%; margin: 0 auto 1rem;
  display: flex; align-items: center; justify-content: center; font-size: 1.5rem;
}
.ef-no-account-icon { background: rgba(239, 68, 68, 0.1); color: #fca5a5; }
.ef-otp-sent-icon { background: rgba(16, 185, 129, 0.1); color: #6ee7b7; }
.ef-no-account-title, .ef-otp-sent-title { font-size: 1.1rem; font-weight: 700; color: #fff; margin-bottom: 0.5rem; }
html[data-theme="light"] .ef-no-account-title, html[data-theme="light"] .ef-otp-sent-title { color: #0f172a; }
.ef-no-account-sub, .ef-otp-sent-sub { color: #94a3b8; font-size: 0.9rem; line-height: 1.5; }

/* ── Premium Auth Tabs ── */
.auth-tabs {
  display: flex;
  background: rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 4px;
  margin-bottom: 2rem;
  width: 100%;
  max-width: 400px;
}

html[data-theme="light"] .auth-tabs {
  background: #f1f5f9;
  border-color: #e2e8f0;
}

.auth-tab {
  flex: 1 1;
  background: transparent;
  border: none;
  color: #94a3b8;
  padding: 0.65rem 0;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  text-align: center;
}

html[data-theme="light"] .auth-tab {
  color: #64748b;
}

.auth-tab.active {
  background: rgba(14, 165, 233, 0.2);
  color: #38bdf8;
  border: 1px solid rgba(14, 165, 233, 0.3);
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.15);
}

html[data-theme="light"] .auth-tab.active {
  background: #ffffff;
  color: #0f172a;
  border: 1px solid rgba(0,0,0,0.05);
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.auth-tab:hover:not(.active) {
  color: #ffffff;
}

html[data-theme="light"] .auth-tab:hover:not(.active) {
  color: #0f172a;
}

/* Hide native checkboxes for custom styled remember-me and terms boxes */
.remember-me input[type="checkbox"],
.ef-remember-label input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginModal.css"],"names":[],"mappings":";AACA,yEAAyE;;AAEzE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oFAAoF;EACpF,gCAAgC;EAChC,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,yDAAyD;EACzD,oCAAoC;EACpC,mFAAmF;EACnF,mBAAmB;AACrB;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,OAAO,uCAAuC,EAAE,UAAU,EAAE;EAC5D,KAAK,iCAAiC,EAAE,UAAU,EAAE;AACtD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,iCAAiC;EACjC,0CAA0C;EAC1C,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,sCAAsC;EACtC,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kDAAkD;AACpD;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,sEAAsE;EACtE,yBAAyB;EACzB;;;kFAGgF;EAChF,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;;;AAIA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B;8FAC4F;EAC5F,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,wDAAwD;EACxD,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,uDAAuD;EACvD,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;AACnB;;;;AAIA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;AAClB;;;;AAIA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,2BAA2B;AAC7B;;;;AAIA,8BAA8B;AAC9B;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,8EAA8E;EAC9E,iCAAiC;EACjC,0CAA0C;;EAE1C,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;;EAErB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oDAAoD;AACtD;;AAEA,qBAAqB;AACrB;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,qDAAqD;EACrD,+CAA+C;EAC/C,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,sDAAsD;AACxD;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;EACxD,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,yDAAyD;EACzD,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,sDAAsD,cAAc,EAAE;;AAEtE;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB,sBAAsB,EAAE;EAC1C,mBAAmB,aAAa,EAAE;EAClC,oBAAoB,WAAW,EAAE,aAAa;EAC9C,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;AAEA,yBAAyB;AACzB;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kBAAkB,EAAE,gBAAgB,EAAE,cAAc;EACpD,8BAA8B,EAAE,uCAAuC;EACvE,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,WAAW;AAC5E;AACA;EACE,mBAAmB,EAAE,qBAAqB,EAAE,cAAc;AAC5D;AACA,oBAAoB,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC/F;EACE,WAAW,EAAE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC1D,eAAe,EAAE,mBAAmB,EAAE,uCAAuC;EAC7E,8BAA8B,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe;EACjF,qBAAqB,EAAE,oBAAoB;AAC7C;AACA;EACE,mBAAmB,EAAE,qBAAqB,EAAE,cAAc;AAC5D;AACA,uBAAuB,kCAAkC,EAAE,mCAAmC,EAAE;AAChG,gDAAgD,mBAAmB,EAAE,qBAAqB,EAAE;AAC5F,kBAAkB,cAAc,EAAE;AAClC,mBAAmB,iBAAiB,EAAE,cAAc,EAAE;AACtD;EACE,gBAAgB,EAAE,YAAY,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB;AACrG;AACA,sBAAsB,cAAc,EAAE;AACtC,+CAA+C,cAAc,EAAE;;AAE/D,+BAA+B,kBAAkB,EAAE,WAAW,EAAE;AAChE;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB;EAClE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,iBAAiB;AAChF;AACA,sBAAsB,kCAAkC,EAAE,cAAc,EAAE;AAC1E,oBAAoB,mCAAmC,EAAE,cAAc,EAAE;AACzE,2CAA2C,iBAAiB,EAAE,gBAAgB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AACpH,6FAA6F,cAAc,EAAE;AAC7G,uCAAuC,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAE5F,4BAA4B;AAC5B;EACE,aAAa;EACb,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yEAAyE;AACzE;;EAEE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB","sourcesContent":["\n/* ── LoginModal.css (Data Lift v2 Ultra-Premium Glassmorphic Theme) ── */\n\n.login-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  /* Dark mode: softer dark overlay so the app's beautiful background shines through */\n  background: rgba(2, 6, 23, 0.65);\n  backdrop-filter: blur(16px) saturate(140%);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: modalFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\nhtml[data-theme=\"light\"] .login-modal-overlay {\n  background: rgba(241, 245, 249, 0.7);\n  backdrop-filter: blur(24px) saturate(150%);\n}\n\n@keyframes modalFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.login-modal-card-container {\n  position: relative;\n  width: 95%;\n  max-width: 1000px;\n  height: 640px;\n  animation: cardSlideIn 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n  /* Dark mode: strong subtle shadow */\n  box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.8), 0 0 40px rgba(14, 165, 233, 0.1);\n  border-radius: 28px;\n}\n\nhtml[data-theme=\"light\"] .login-modal-card-container {\n  box-shadow: 0 30px 60px -15px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0,0,0,0.05);\n}\n\n@keyframes cardSlideIn {\n  from { transform: translateY(30px) scale(0.95); opacity: 0; }\n  to { transform: translateY(0) scale(1); opacity: 1; }\n}\n\n.login-modal-close-btn {\n  position: absolute;\n  top: -45px;\n  right: 0;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #94a3b8;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 10005;\n  backdrop-filter: blur(12px);\n  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.login-modal-close-btn:hover {\n  transform: scale(1.1) rotate(90deg);\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.3);\n  background: rgba(15, 23, 42, 0.9);\n  box-shadow: 0 0 15px rgba(255,255,255,0.1);\n}\n\nhtml[data-theme=\"light\"] .login-modal-close-btn {\n  background: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  color: #64748b;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\nhtml[data-theme=\"light\"] .login-modal-close-btn:hover {\n  color: #0f172a;\n  border-color: #cbd5e1;\n}\n\n/* ── Layout ── */\n.auth-container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  border-radius: 28px;\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.05);\n  overflow: hidden;\n}\n\nhtml[data-theme=\"light\"] .auth-container {\n  background: #ffffff;\n  border: none;\n  box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 1);\n}\n\n/* ── LEFT PANEL ── */\n.auth-left-panel {\n  width: 45%;\n  /* Dark mode: vibrant rich blue gradient to create stunning contrast */\n  background-color: #020617;\n  background-image: \n    radial-gradient(circle at 15% 50%, rgba(99, 102, 241, 0.22), transparent 50%),\n    radial-gradient(circle at 85% 30%, rgba(14, 165, 233, 0.25), transparent 50%),\n    radial-gradient(circle at 50% 100%, rgba(16, 185, 129, 0.15), transparent 50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 2.5rem;\n  color: white;\n  position: relative;\n  overflow: hidden;\n  border-right: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n\n\n.auth-left-panel::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-size: 40px 40px;\n  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.04) 1px, transparent 1px),\n                    linear-gradient(to bottom, rgba(255, 255, 255, 0.04) 1px, transparent 1px);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.auth-left-content {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 2;\n}\n\n.auth-avatar-icon {\n  margin-bottom: 1.8rem;\n  color: #ffffff;\n  filter: drop-shadow(0 4px 20px rgba(255, 255, 255, 0.3));\n  transform: scale(1.1);\n}\n\nhtml[data-theme=\"light\"] .auth-avatar-icon {\n  color: #38bdf8;\n  filter: drop-shadow(0 0 15px rgba(56, 189, 248, 0.4));\n}\n\n.auth-left-content h2 {\n  font-family: 'Outfit', sans-serif;\n  font-size: 2.4rem;\n  font-weight: 800;\n  margin-bottom: 1.2rem;\n  line-height: 1.15;\n  letter-spacing: -0.03em;\n  background: linear-gradient(to right, #ffffff, #94a3b8);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-shadow: none;\n}\n\n\n\n.auth-left-content p {\n  font-size: 0.95rem;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.75);\n  margin-bottom: 2.5rem;\n  max-width: 320px;\n}\n\n\n\n.auth-feature-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n  max-width: 340px;\n}\n\n.auth-feature-chips .chip {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(56, 189, 248, 0.2);\n  color: #e0f2fe;\n  padding: 0.45rem 1rem;\n  border-radius: 8px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  backdrop-filter: blur(12px);\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\n}\n\n.auth-feature-chips .chip.active {\n  background: rgba(14, 165, 233, 0.25);\n  border-color: rgba(14, 165, 233, 0.6);\n  color: #ffffff;\n  box-shadow: 0 0 12px rgba(14, 165, 233, 0.3);\n}\n\n.auth-feature-chips .chip.disabled {\n  background: rgba(15, 23, 42, 0.3);\n  border-color: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.4);\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.auth-feature-chips .chip:hover:not(.disabled) {\n  background: rgba(56, 189, 248, 0.15);\n  border-color: rgba(56, 189, 248, 0.4);\n  transform: translateY(-2px);\n}\n\n\n\n/* ── RIGHT PANEL (FORMS) ── */\n.auth-right-panel {\n  width: 55%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 2rem 4rem;\n  position: relative;\n  /* Dark mode: Ultra-premium dark frosted glass to contrast with vibrant left */\n  background: rgba(10, 15, 30, 0.4);\n  backdrop-filter: blur(40px) saturate(200%);\n\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n.auth-right-panel::-webkit-scrollbar {\n  display: none;\n}\n\nhtml[data-theme=\"light\"] .auth-right-panel {\n  background: #ffffff;\n  backdrop-filter: none;\n\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n.auth-right-panel::-webkit-scrollbar {\n  display: none;\n}\n\n.auth-content {\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin: auto 0;\n}\n\n.fade-in {\n  animation: fadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n/* ── Typography ── */\n.auth-content h1 {\n  font-family: 'Outfit', sans-serif;\n  font-size: 2.2rem;\n  font-weight: 800;\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.03em;\n  color: #ffffff;\n  text-align: left;\n}\n\nhtml[data-theme=\"light\"] .auth-content h1 {\n  color: #0f172a;\n}\n\n.auth-form-subtitle {\n  font-size: 0.95rem;\n  color: #94a3b8;\n  margin-bottom: 2rem;\n  text-align: left;\n  line-height: 1.5;\n}\n\nhtml[data-theme=\"light\"] .auth-form-subtitle {\n  color: #64748b;\n}\n\n/* ── Forms and Inputs ── */\n.auth-content form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.input-group {\n  position: relative;\n  width: 100%;\n}\n\n.input-group input {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3) !important;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  padding: 0.75rem 1rem 0.75rem 2.8rem !important;\n  border-radius: 12px !important;\n  color: #ffffff !important;\n  font-size: 0.95rem;\n  transition: all 0.25s ease !important;\n  box-shadow: inset 0 2px 4px rgba(0,0,0,0.2) !important;\n}\n\nhtml[data-theme=\"light\"] .input-group input {\n  background: #f8fafc !important;\n  border: 1px solid #e2e8f0 !important;\n  color: #0f172a !important;\n  box-shadow: inset 0 2px 4px rgba(0,0,0,0.02) !important;\n}\n\n.input-group input:focus {\n  border-color: #38bdf8 !important;\n  box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.2) !important;\n  background: rgba(0, 0, 0, 0.5) !important;\n  outline: none;\n}\n\nhtml[data-theme=\"light\"] .input-group input:focus {\n  border-color: #0ea5e9 !important;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.15) !important;\n  background: #ffffff !important;\n}\n\n.input-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #64748b;\n  pointer-events: none;\n  transition: color 0.3s ease;\n  z-index: 10;\n}\n\n.input-group input:focus + .input-icon {\n  color: #38bdf8;\n}\n\nhtml[data-theme=\"light\"] .input-group input:focus + .input-icon {\n  color: #0ea5e9;\n}\n\n/* Checkbox & Forgot Password */\n.auth-form-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.85rem;\n  margin: 0.2rem 0 0.5rem 0;\n  width: 100%;\n}\n\n.remember-me {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  color: #cbd5e1;\n}\n\nhtml[data-theme=\"light\"] .remember-me {\n  color: #475569;\n}\n\n.checkbox-custom {\n  height: 18px;\n  width: 18px;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  position: relative;\n  transition: all 0.2s;\n}\n\nhtml[data-theme=\"light\"] .checkbox-custom {\n  background: #ffffff;\n  border-color: #cbd5e1;\n}\n\n.remember-me input:checked ~ .checkbox-custom {\n  background: #0ea5e9;\n  border-color: #0ea5e9;\n}\n\n.checkbox-custom:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n  left: 5px;\n  top: 2px;\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.remember-me input:checked ~ .checkbox-custom:after { display: block; }\n\n.forgot-password {\n  margin-left: auto;\n}\n\n.forgot-password a {\n  color: #38bdf8;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.2s;\n}\n\nhtml[data-theme=\"light\"] .forgot-password a {\n  color: #0ea5e9;\n}\n\n.forgot-password a:hover {\n  color: #e0f2fe;\n}\n\nhtml[data-theme=\"light\"] .forgot-password a:hover {\n  color: #0284c7;\n}\n\n/* Submit Button */\n.auth-submit-btn {\n  width: 100%;\n  padding: 0.9rem;\n  border-radius: 12px;\n  border: none;\n  background: #0ea5e9;\n  color: white;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 4px 15px rgba(14, 165, 233, 0.4);\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  margin-top: 0.5rem;\n}\n\nhtml[data-theme=\"light\"] .auth-submit-btn {\n  background: #0f172a;\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);\n}\n\n.auth-submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  background: #38bdf8;\n  box-shadow: 0 8px 25px rgba(56, 189, 248, 0.5);\n}\n\nhtml[data-theme=\"light\"] .auth-submit-btn:hover:not(:disabled) {\n  background: #1e293b;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.25);\n}\n\n.auth-submit-btn:disabled {\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.3);\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\nhtml[data-theme=\"light\"] .auth-submit-btn:disabled {\n  background: #e2e8f0;\n  color: #94a3b8;\n  border: none;\n}\n\n/* Switcher Link */\n.auth-switch-link {\n  margin-top: 2rem;\n  font-size: 0.95rem;\n  text-align: center;\n}\n\n.auth-switch-link .text-muted {\n  color: #94a3b8;\n}\n\nhtml[data-theme=\"light\"] .auth-switch-link .text-muted {\n  color: #64748b;\n}\n\n.switch-btn {\n  background: none;\n  border: none;\n  color: #38bdf8;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0.95rem;\n  transition: color 0.2s;\n}\n\nhtml[data-theme=\"light\"] .switch-btn {\n  color: #0ea5e9;\n}\n\n.switch-btn:hover {\n  color: #e0f2fe;\n  text-decoration: underline;\n}\n\nhtml[data-theme=\"light\"] .switch-btn:hover {\n  color: #0284c7;\n}\n\n/* Dividers & Footer */\n.divider-text {\n  width: 100%;\n  text-align: center;\n  color: #64748b;\n  font-size: 0.8rem;\n  font-weight: 600;\n  margin: 1.2rem 0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.divider-text::before, .divider-text::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: rgba(255,255,255,0.1);\n  margin: 0 10px;\n}\n\nhtml[data-theme=\"light\"] .divider-text::before,\nhtml[data-theme=\"light\"] .divider-text::after {\n  background: rgba(0,0,0,0.1);\n}\n\n.copyright-tag {\n  color: #64748b;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-top: 2rem;\n  text-align: center;\n}\n\n/* SSO Buttons */\n.sso-buttons-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.google-sso-btn, .github-sso-btn {\n  width: 100%;\n  padding: 0.85rem;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.03);\n  color: #ffffff;\n  font-size: 0.95rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\nhtml[data-theme=\"light\"] .google-sso-btn, \nhtml[data-theme=\"light\"] .github-sso-btn {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  color: #0f172a;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.02);\n}\n\n.google-sso-btn:hover, .github-sso-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.2);\n  transform: translateY(-1px);\n}\n\nhtml[data-theme=\"light\"] .google-sso-btn:hover, \nhtml[data-theme=\"light\"] .github-sso-btn:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n/* Error/Success Badges */\n.auth-error-badge {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  color: #fca5a5;\n  padding: 0.8rem;\n  border-radius: 10px;\n  font-size: 0.85rem;\n  width: 100%;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\nhtml[data-theme=\"light\"] .auth-error-badge {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #ef4444;\n}\n\n.auth-success-badge {\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid rgba(16, 185, 129, 0.2);\n  color: #6ee7b7;\n  padding: 0.8rem;\n  border-radius: 10px;\n  font-size: 0.85rem;\n  width: 100%;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\nhtml[data-theme=\"light\"] .auth-success-badge {\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n  color: #059669;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .auth-container { flex-direction: column; }\n  .auth-left-panel { display: none; }\n  .auth-right-panel { width: 100%; padding: 2rem; \n  overflow-y: auto;\n  scrollbar-width: none;\n}\n.auth-right-panel::-webkit-scrollbar {\n  display: none;\n}\n}\n\n/* EF-Methods overrides */\n.ef-email-badge {\n  display: flex; align-items: center; justify-content: center;\n  font-size: 0.85rem; font-weight: 600; color: #cbd5e1;\n  background: rgba(0, 0, 0, 0.3); border: 1px solid rgba(255,255,255,0.1);\n  border-radius: 8px; padding: 0.5rem 1rem; margin-bottom: 1rem; width: 100%;\n}\nhtml[data-theme=\"light\"] .ef-email-badge {\n  background: #f8fafc; border-color: #e2e8f0; color: #475569;\n}\n.ef-methods-label { font-size: 0.85rem; font-weight: 600; color: #94a3b8; margin-bottom: 1rem; }\n.ef-method-btn {\n  width: 100%; display: flex; align-items: center; gap: 12px;\n  padding: 0.9rem; border-radius: 12px; border: 1px solid rgba(255,255,255,0.1);\n  background: rgba(0, 0, 0, 0.2); color: #e2e8f0; font-weight: 600; cursor: pointer;\n  margin-bottom: 0.6rem; transition: all 0.2s;\n}\nhtml[data-theme=\"light\"] .ef-method-btn {\n  background: #ffffff; border-color: #e2e8f0; color: #1e293b;\n}\n.ef-method-btn:hover { background: rgba(255,255,255,0.05); border-color: rgba(255,255,255,0.2); }\nhtml[data-theme=\"light\"] .ef-method-btn:hover { background: #f8fafc; border-color: #cbd5e1; }\n.ef-method-icon { color: #94a3b8; }\n.ef-method-arrow { margin-left: auto; color: #64748b; }\n.ef-back-link {\n  background: none; border: none; color: #64748b; font-weight: 600; cursor: pointer; margin-top: 1rem;\n}\n.ef-back-link:hover { color: #38bdf8; }\nhtml[data-theme=\"light\"] .ef-back-link:hover { color: #0ea5e9; }\n\n.ef-no-account, .ef-otp-sent { text-align: center; width: 100%; }\n.ef-no-account-icon, .ef-otp-sent-icon {\n  width: 50px; height: 50px; border-radius: 50%; margin: 0 auto 1rem;\n  display: flex; align-items: center; justify-content: center; font-size: 1.5rem;\n}\n.ef-no-account-icon { background: rgba(239, 68, 68, 0.1); color: #fca5a5; }\n.ef-otp-sent-icon { background: rgba(16, 185, 129, 0.1); color: #6ee7b7; }\n.ef-no-account-title, .ef-otp-sent-title { font-size: 1.1rem; font-weight: 700; color: #fff; margin-bottom: 0.5rem; }\nhtml[data-theme=\"light\"] .ef-no-account-title, html[data-theme=\"light\"] .ef-otp-sent-title { color: #0f172a; }\n.ef-no-account-sub, .ef-otp-sent-sub { color: #94a3b8; font-size: 0.9rem; line-height: 1.5; }\n\n/* ── Premium Auth Tabs ── */\n.auth-tabs {\n  display: flex;\n  background: rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 4px;\n  margin-bottom: 2rem;\n  width: 100%;\n  max-width: 400px;\n}\n\nhtml[data-theme=\"light\"] .auth-tabs {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n}\n\n.auth-tab {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  padding: 0.65rem 0;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n  text-align: center;\n}\n\nhtml[data-theme=\"light\"] .auth-tab {\n  color: #64748b;\n}\n\n.auth-tab.active {\n  background: rgba(14, 165, 233, 0.2);\n  color: #38bdf8;\n  border: 1px solid rgba(14, 165, 233, 0.3);\n  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.15);\n}\n\nhtml[data-theme=\"light\"] .auth-tab.active {\n  background: #ffffff;\n  color: #0f172a;\n  border: 1px solid rgba(0,0,0,0.05);\n  box-shadow: 0 4px 12px rgba(0,0,0,0.05);\n}\n\n.auth-tab:hover:not(.active) {\n  color: #ffffff;\n}\n\nhtml[data-theme=\"light\"] .auth-tab:hover:not(.active) {\n  color: #0f172a;\n}\n\n/* Hide native checkboxes for custom styled remember-me and terms boxes */\n.remember-me input[type=\"checkbox\"],\n.ef-remember-label input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
